export default __webpack_public_path__ + "static/B0034-2b75165ebacfdf55afac3c72772d63da.png";